import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';
import tr from './locales/tr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      tr: { translation: tr },
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'nexvera_lang',
      caches: ['localStorage'],
    },
    lng: 'tr',       // Varsayilan Turkce (musteriler Turkiye'de)
    // tr.json bazi key'leri eksik olabilir (dashboard.*, settings.*, devices.* vs)
    // o zaman English'e dus. Aksi halde ekranda "dashboard.operationalOverview"
    // gibi ham key'ler gorunur (2026-08-08 kullanici raporlari).
    // NOT: i18next fallbackLng array'i bazi sururmlerde calismiyor — string kullan
    fallbackLng: 'en',
    // tr.json eksik key varsa parent lng en'e dus + missing'i console'a bas (debug)
    saveMissing: false,
    returnEmptyString: false,
    parseMissingKeyHandler: (key: string) => {
      // Ham key gostermek yerine son segmenti gost (dashboard.operationalOverview -> operationalOverview)
      const parts = key.split('.');
      return parts[parts.length - 1] || key;
    },
    supportedLngs: ['tr', 'en', 'ar'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // prevent render before i18n is ready
    },
  });

// Dil değiştiğinde HTML dir ve lang attribute güncelle
i18n.on('languageChanged', (lng) => {
  const isRTL = lng === 'ar';
  document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  // Tailwind RTL prefix'leri için body'e class ekle
  document.body.classList.toggle('rtl', isRTL);
  document.body.classList.toggle('ltr', !isRTL);
});

export default i18n;
